import { Box, Button } from "@mui/material";
import React from "react";

const ContainerSubmitButton = (props) => {
  const { label = "continue", type = "submit" } = props;
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          size="small"
          variant="contained"
          sx={{
            // borderRadius: 2,
            // mt: 1,
            // bgcolor: "#a6ce39",

            borderRadius: "1",
            mt: 1,
            bgcolor: "#a6ce39",
            borderRadius: 3,
            bgcolor: "#a6ce39",
            width: "200px",
          }}
          type={type}
          {...props}
        >
          {label}
        </Button>
      </Box>
    </>
  );
};

export default ContainerSubmitButton;
